// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.profile-tournaments-teams-summary__container {
    padding: 24px 16px 8px 16px;
    background-color: var(--white-color);
    border-radius: 14px;
    margin: 16px 0;
}

.profile-tournaments-teams-summary__title {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 24px;
}

.profile-tournaments-teams-summary__title .baloa-subtitle-2 {
    color: var(--primary-dark-color);
}

.profile-tournaments-teams-summary__title__tooltip.baloa-table-column {
    color: var(--primary-dark-color);
    font-weight: var(--font-regular);
}

.profile-tournaments-teams-summary__tooltip {
    position: relative;
}

.profile-tournaments-teams-summary__tooltip .hubicon-help_fill::before {
    color: var(--new-green-color);
    opacity: 0.64;
    cursor: pointer;
    font-size: 18px;
}

.profile-tournaments-teams-summary__tooltip .baloa-table-column {
    font-weight: var(--font-regular);
    color: var(--primary-dark-color);
    padding: 13px 10px;
    position: absolute;
    width: 250px;
    height: 125px;
    background: var(--white-color);
    border: 1px solid var(--new-gray-background-color);
    border-radius: 5px;
    filter: drop-shadow(0px 4px 4px rgba(0, 0, 0, 0.15));
    bottom: 42px;
    left: -115px;
    display: none;
}

.profile-tournaments-teams-summary__tooltip:hover .baloa-table-column {
    display: block;
}

.profile-tournaments-teams-summary__tooltip .baloa-table-column:after {
    content: "";
    position: absolute;
    bottom: -10px;
    left: 50%;
    border-left: 10px solid transparent;
    border-right: 10px solid transparent;
    border-top: 10px solid var(--white-color);
    transform: translateX(-50%);
}

.profile-tournaments-teams-summary__unlock-values__text .hubicon-info {
    font-size: 18px;
}

.profile-tournaments-teams-summary__unlock-values__text .hubicon-info::before {
    color: var(--new-informative-banner-color);
}

.profile-tournaments-teams-summary__unlock-values__text .hubicon-award_star {
    font-size: 22px;
}

.profile-tournaments-teams-summary__unlock-values__action {
    display: flex;
    align-items: center;
    justify-content: space-between;
    background-color: var(--new-informative-banner-bg-color);
    padding: 10px;
    border-radius: 4px;
}

.profile-tournaments-teams-summary__unlock-values__action .primary-button {
    padding: 8px 12px;
}

.profile-tournaments-teams-summary__unlock-values__text {
    display: flex;
    align-items: center;
    justify-content: flex-start; 
    gap: 10px;  
}

.profile-tournaments-teams-summary__view-all.baloa-normal-medium {
    width: 100%;
    text-align: center;
    color: var(--new-green-color);
    margin-top: 14px;
    cursor: pointer;
}

.profile-tournaments-teams-summary__unlock-values__text .baloa-normal-medium {
    color: var(--primary-very-dark-color);
    display: flex;
    align-items: center;
    justify-content: flex-start;
    gap: 10px;
}

@media screen and ( max-width: 440px ) { /* Cambio de 430px a 440px */
    .profile-tournaments-teams-summary__container {
        margin-left: 10px;
        margin-right: 10px;
        box-shadow: 0px 1px 4px rgba(0, 0, 0, 0.12);
    }

    .profile-tournaments-teams-summary__title .baloa-subtitle-2 {
        font-size: 14px;
        line-height: 16px;
    }

    .profile-tournaments-teams-summary__title {
        margin-bottom: 14px;
    }

    .profile-tournaments-teams-summary__container {
        padding: 10px;        
    }

    .profile-tournaments-teams-summary__unlock-values__text .baloa-normal-medium {
        font-size: 13px;
        line-height: 15px;
    }

    .profile-tournaments-teams-summary__tooltip .baloa-table-column {
        top: -42px;
        left: -180px;
    }

    .profile-tournaments-teams-summary__tooltip .baloa-table-column:after {
        
        content: '';
        position: absolute;
        top: 50%;
        left: 105%;
        transform: translate(-50%, -50%) rotate(180deg);
        width: 0;
        height: 0;
        border-top: 10px solid transparent;
        border-right: 10px solid var(--white-color);
        border-bottom: 10px solid transparent;
        bottom: unset;
    }

    .profile-tournaments-teams-summary__tooltip .baloa-table-column {
        width: 170px;
        height: 98px;        
    }

    .profile-tournaments-teams-summary__unlock-values__text .hubicon-award_star {
        font-size: 18px;
    }
    
}`, "",{"version":3,"sources":["webpack://./src/app/profiles/components/profile-tournaments-teams-summary/ProfileTournamentsTeamsSummaryComponent.styles.css"],"names":[],"mappings":"AAAA;IACI,2BAA2B;IAC3B,oCAAoC;IACpC,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,gCAAgC;IAChC,gCAAgC;AACpC;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,6BAA6B;IAC7B,aAAa;IACb,eAAe;IACf,eAAe;AACnB;;AAEA;IACI,gCAAgC;IAChC,gCAAgC;IAChC,kBAAkB;IAClB,kBAAkB;IAClB,YAAY;IACZ,aAAa;IACb,8BAA8B;IAC9B,kDAAkD;IAClD,kBAAkB;IAClB,oDAAoD;IACpD,YAAY;IACZ,YAAY;IACZ,aAAa;AACjB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,aAAa;IACb,SAAS;IACT,mCAAmC;IACnC,oCAAoC;IACpC,yCAAyC;IACzC,2BAA2B;AAC/B;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,0CAA0C;AAC9C;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,wDAAwD;IACxD,aAAa;IACb,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,2BAA2B;IAC3B,SAAS;AACb;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,6BAA6B;IAC7B,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,qCAAqC;IACrC,aAAa;IACb,mBAAmB;IACnB,2BAA2B;IAC3B,SAAS;AACb;;AAEA,yCAAyC,4BAA4B;IACjE;QACI,iBAAiB;QACjB,kBAAkB;QAClB,2CAA2C;IAC/C;;IAEA;QACI,eAAe;QACf,iBAAiB;IACrB;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,eAAe;QACf,iBAAiB;IACrB;;IAEA;QACI,UAAU;QACV,YAAY;IAChB;;IAEA;;QAEI,WAAW;QACX,kBAAkB;QAClB,QAAQ;QACR,UAAU;QACV,+CAA+C;QAC/C,QAAQ;QACR,SAAS;QACT,kCAAkC;QAClC,2CAA2C;QAC3C,qCAAqC;QACrC,aAAa;IACjB;;IAEA;QACI,YAAY;QACZ,YAAY;IAChB;;IAEA;QACI,eAAe;IACnB;;AAEJ","sourcesContent":[".profile-tournaments-teams-summary__container {\n    padding: 24px 16px 8px 16px;\n    background-color: var(--white-color);\n    border-radius: 14px;\n    margin: 16px 0;\n}\n\n.profile-tournaments-teams-summary__title {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    margin-bottom: 24px;\n}\n\n.profile-tournaments-teams-summary__title .baloa-subtitle-2 {\n    color: var(--primary-dark-color);\n}\n\n.profile-tournaments-teams-summary__title__tooltip.baloa-table-column {\n    color: var(--primary-dark-color);\n    font-weight: var(--font-regular);\n}\n\n.profile-tournaments-teams-summary__tooltip {\n    position: relative;\n}\n\n.profile-tournaments-teams-summary__tooltip .hubicon-help_fill::before {\n    color: var(--new-green-color);\n    opacity: 0.64;\n    cursor: pointer;\n    font-size: 18px;\n}\n\n.profile-tournaments-teams-summary__tooltip .baloa-table-column {\n    font-weight: var(--font-regular);\n    color: var(--primary-dark-color);\n    padding: 13px 10px;\n    position: absolute;\n    width: 250px;\n    height: 125px;\n    background: var(--white-color);\n    border: 1px solid var(--new-gray-background-color);\n    border-radius: 5px;\n    filter: drop-shadow(0px 4px 4px rgba(0, 0, 0, 0.15));\n    bottom: 42px;\n    left: -115px;\n    display: none;\n}\n\n.profile-tournaments-teams-summary__tooltip:hover .baloa-table-column {\n    display: block;\n}\n\n.profile-tournaments-teams-summary__tooltip .baloa-table-column:after {\n    content: \"\";\n    position: absolute;\n    bottom: -10px;\n    left: 50%;\n    border-left: 10px solid transparent;\n    border-right: 10px solid transparent;\n    border-top: 10px solid var(--white-color);\n    transform: translateX(-50%);\n}\n\n.profile-tournaments-teams-summary__unlock-values__text .hubicon-info {\n    font-size: 18px;\n}\n\n.profile-tournaments-teams-summary__unlock-values__text .hubicon-info::before {\n    color: var(--new-informative-banner-color);\n}\n\n.profile-tournaments-teams-summary__unlock-values__text .hubicon-award_star {\n    font-size: 22px;\n}\n\n.profile-tournaments-teams-summary__unlock-values__action {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    background-color: var(--new-informative-banner-bg-color);\n    padding: 10px;\n    border-radius: 4px;\n}\n\n.profile-tournaments-teams-summary__unlock-values__action .primary-button {\n    padding: 8px 12px;\n}\n\n.profile-tournaments-teams-summary__unlock-values__text {\n    display: flex;\n    align-items: center;\n    justify-content: flex-start; \n    gap: 10px;  \n}\n\n.profile-tournaments-teams-summary__view-all.baloa-normal-medium {\n    width: 100%;\n    text-align: center;\n    color: var(--new-green-color);\n    margin-top: 14px;\n    cursor: pointer;\n}\n\n.profile-tournaments-teams-summary__unlock-values__text .baloa-normal-medium {\n    color: var(--primary-very-dark-color);\n    display: flex;\n    align-items: center;\n    justify-content: flex-start;\n    gap: 10px;\n}\n\n@media screen and ( max-width: 440px ) { /* Cambio de 430px a 440px */\n    .profile-tournaments-teams-summary__container {\n        margin-left: 10px;\n        margin-right: 10px;\n        box-shadow: 0px 1px 4px rgba(0, 0, 0, 0.12);\n    }\n\n    .profile-tournaments-teams-summary__title .baloa-subtitle-2 {\n        font-size: 14px;\n        line-height: 16px;\n    }\n\n    .profile-tournaments-teams-summary__title {\n        margin-bottom: 14px;\n    }\n\n    .profile-tournaments-teams-summary__container {\n        padding: 10px;        \n    }\n\n    .profile-tournaments-teams-summary__unlock-values__text .baloa-normal-medium {\n        font-size: 13px;\n        line-height: 15px;\n    }\n\n    .profile-tournaments-teams-summary__tooltip .baloa-table-column {\n        top: -42px;\n        left: -180px;\n    }\n\n    .profile-tournaments-teams-summary__tooltip .baloa-table-column:after {\n        \n        content: '';\n        position: absolute;\n        top: 50%;\n        left: 105%;\n        transform: translate(-50%, -50%) rotate(180deg);\n        width: 0;\n        height: 0;\n        border-top: 10px solid transparent;\n        border-right: 10px solid var(--white-color);\n        border-bottom: 10px solid transparent;\n        bottom: unset;\n    }\n\n    .profile-tournaments-teams-summary__tooltip .baloa-table-column {\n        width: 170px;\n        height: 98px;        \n    }\n\n    .profile-tournaments-teams-summary__unlock-values__text .hubicon-award_star {\n        font-size: 18px;\n    }\n    \n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
